import { render, staticRenderFns } from "./InsightEditList.vue?vue&type=template&id=b1293936&scoped=true"
import script from "./InsightEditList.vue?vue&type=script&lang=js"
export * from "./InsightEditList.vue?vue&type=script&lang=js"
import style0 from "./InsightEditList.vue?vue&type=style&index=0&id=b1293936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1293936",
  null
  
)

export default component.exports